<ng-container *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title>Submit New {{ facilityTitleType }} at {{ airport.name }}</h1>
  <mat-dialog-content [formGroup]='formGroup'>
    <div class="form-container">
      <p>Provide the name of the new {{ facilityType }} below.  After submitting, the new {{ facilityType }}
      listing template will open and allow additional details and services to be specified. All new submissions
      require AOPA approval before appearing in the Airport Directory. This process normally takes 1-2
      business days. You will be notified via email when the listing has been approved or if additional
      information is needed.</p>
      <p>There are no fees for having a {{ facilityType }} listing in the AOPA Airport Directory. By submitting
      a new {{ facilityType }} for inclusion in the AOPA Airport Directory, you agree to the
      <a href="https://www.aopa.org/terms-of-use" target="_blank">AOPA Terms of Use</a> and <a href="https://www.aopa.org/privacy-policy" target="_blank">Privacy Policy</a>.</p>
      <div class="user-submit-new-business__checkbox">
        <mat-checkbox formControlName="terms" color="primary">I agree to the AOPA Terms of Use and Privacy Policy</mat-checkbox>
      </div>
      <mat-form-field>
        <input matInput formControlName="name" placeholder="Name of Business *">
      </mat-form-field>

      <fieldset class="fieldset-container" style="padding-bottom: 5px">
        <legend>Address</legend>
        <!--style="padding-left: 0; padding-right: 0; padding-bottom: 0"-->
        <!--style="margin-left: 0; margin-right: 0; margin-bottom: 0"-->
        <mat-accordion>
          <!-- Business Address Section-->
          <mat-expansion-panel (opened)="businessPanelOpened()" (closed)="businessPanelClosed()" [expanded]="businessPanelIsActive">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Business Address
              </mat-panel-title>
              <mat-panel-description>
                {{businessPanelText}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <h2></h2>
            <p>
              <mat-form-field class="inputs">
                <input matInput
                       placeholder="Street 1 *"
                       formControlName="street1">
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="inputs">
                <input matInput
                       placeholder="Street 2"
                       formControlName="street2">
              </mat-form-field>
            </p>
            <p class="input address_line_row">
              <mat-form-field class="address_row_item cityField">
                <input matInput
                       placeholder="City *"
                       formControlName="city">
              </mat-form-field>
              <mat-form-field *ngIf="states.length" class="address_row_item">
                <mat-select formControlName="stateProvince" placeholder="Select State *">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let state of states" value="{{state.stateCode}}">{{state.description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="!states.length" class="address_row_item">
                <input matInput
                       placeholder="Enter State"
                       formControlName="stateProvince">
              </mat-form-field>
              <mat-form-field class="address_row_item">
                <input matInput
                       placeholder="{{postalCodePlaceHolder}}"
                       formControlName="postalCode">
              </mat-form-field>
              <mat-form-field>
                <mat-select [id]="1" formControlName="country" placeholder="Select Country"
                            (selectionChange)="countryChange($event)">
                  <mat-option value="">None</mat-option>
                  <mat-option *ngFor="let country of countries" value="{{country.countryCodeIso2.trim()}}">
                    {{country.description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </p>
          </mat-expansion-panel>
          <!-- Mailing Address Section-->
          <mat-expansion-panel  (opened)="mailingPanelOpened()" (closed)="mailingPanelClosed()" [expanded]="!businessPanelIsActive">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Mailing Address
              </mat-panel-title>
              <mat-panel-description>
                &nbsp;&nbsp;{{mailingPanelText}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-checkbox formControlName="addressSame" (change)="addressSameChange($event)">Is same as business address</mat-checkbox>
            <div id="mailingAddress">
              <p>
                <mat-form-field class="inputs">
                  <input matInput
                         placeholder="Street 1"
                         formControlName="mailingStreet1">
                </mat-form-field>
              </p>
              <p>
                <mat-form-field class="inputs">
                  <input matInput
                         placeholder="Street 2"
                         formControlName="mailingStreet2">
                </mat-form-field>
              </p>
              <p class="inputs">
                <mat-form-field id="cityField">
                  <input matInput
                         placeholder="City"
                         formControlName="mailingCity">
                </mat-form-field>
                <mat-form-field *ngIf="statesMailing.length" class="address_row_item">
                  <mat-select formControlName="mailingStateProvince" placeholder="Select State">
                    <mat-option value="">None</mat-option>
                    <mat-option *ngFor="let state of statesMailing" value="{{state.stateCode}}">{{state.description}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="!statesMailing.length" class="address_row_item">
                  <input matInput
                         placeholder="Enter State"
                         formControlName="mailingStateProvince">
                </mat-form-field>
                <mat-form-field id="postalField">
                  <input matInput
                         placeholder="{{postalCodePlaceHolder}}"
                         formControlName="mailingPostalCode">
                </mat-form-field>
                <mat-form-field>
                  <mat-select [id]="2" formControlName="mailingCountry" placeholder="Select Country"
                              (selectionChange)="countryChange($event)">
                    <mat-option value="">None</mat-option>
                    <mat-option *ngFor="let country of countries" value="{{country.countryCodeIso2.trim()}}">
                      {{country.description}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </fieldset>
      <fieldset class="fieldset-container">
        <legend>Contact and Website</legend>
        <p class="inputs">
          <mat-form-field id="phoneField">
            <input #phone
                   matInput
                   placeholder="Phone"
                   formControlName="phone"
                   maxlength="14"
                   (blur)="phoneFieldBlur('phone')"
                   (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
          </mat-form-field>
          <mat-form-field id="faxField">
            <input #fax
                   matInput
                   placeholder="Fax"
                   formControlName="fax"
                   maxlength="14"
                   (blur)="phoneFieldBlur('fax')"
                   (keyup)="phoneFieldKeyUp($event, 'fax', fax)">
          </mat-form-field>
        </p>
        <p class="inputs">
          <mat-form-field id="websiteField">
            <input matInput
                   placeholder="Website"
                   formControlName="webAddress">
          </mat-form-field>
          <mat-form-field id="emailField">
            <input matInput
                   placeholder="Email"
                   formControlName="email">
          </mat-form-field>
        </p>
      </fieldset>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onSubmit()" [disabled]="!isValid()">Submit</button>
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-container>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner class="spinner" [diameter]="200" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
